// =========================================================
// * Pace Delivery Dashboard
// =========================================================

// * Product Page: https://themesberg.com/product/dashboard/volt-react
// * Copyright 2021 Themesberg (https://www.themesberg.com)
// * Official Repository: https://github.com/themesberg/volt-react-dashboard
// * License: MIT License (https://themesberg.com/licensing)

// * Designed and coded by https://themesberg.com

// =========================================================

// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. Please contact us to request a removal.

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
// import store from "./store";
import configureStore from "./configureStore"; // for production
//import configureStore from "./configureStoreDevEnv"; // for Development Environment
import {
  HashRouter,
} from 'react-router-dom';


// core styles
import "./scss/volt.scss";

// vendor styles
import "react-datetime/css/react-datetime.css";
import HomePage from "./pages/HomePage";

import ScrollToTop from "./components/ScrollToTop";

const store = configureStore();

const renderApp = () =>
  ReactDOM.render(
    <Provider store={store}>
      <HashRouter>
        <ScrollToTop />
        <HomePage />
      </HashRouter>
    </Provider>,
    document.getElementById("root")
  );

if (process.env.NODE_ENV !== 'production' && module.hot) {
  module.hot.accept('./pages/HomePage', renderApp);
}

renderApp();